import {NgModule} from '@angular/core';
import {SegmentComponent} from './item';
import {IonicModule} from '@ionic/angular';
import {NgClass, NgForOf, NgIf} from '@angular/common';
import {CounterComponentModule} from '../counter/item.module';
import {BlockElementLabelComponentModule} from 'app/components/blocks/components/blockElementLabel/item.module';

@NgModule({
  imports: [
    IonicModule,
    NgForOf,
    NgIf,
    NgClass,
    CounterComponentModule,
    BlockElementLabelComponentModule
  ],
  exports: [
    SegmentComponent
  ],
  declarations: [SegmentComponent],
  providers: [],
})
export class SegmentComponentModule {
}
